import {Component, DestroyRef, inject, Inject, OnInit} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef, MatDialog} from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { InstancesService } from 'src/app/services/api/instances.service';
import { RunbookService } from 'src/app/services/api/runbook.service';
import { ComponentsService } from 'src/app/services/api/components.service';
import { RedirectionDialogComponent } from 'src/app/components/redirection-dialog/redirection-dialog.component';
import { translate } from '@jsverse/transloco';
import { UrlService } from 'src/app/services/util/url.service';

@Component({
  selector: 'app-runbook-popup',
  templateUrl: './runbook-popup.component.html',
  styleUrl: './runbook-popup.component.scss',
  standalone: false
})
export class RunbookPopupComponent implements OnInit {
private destroyRef = inject(DestroyRef);
  value: any
  runbook: any;
  instance: any;
  dynamicParamName : any;
  dynamicParams: any;
  filteredComponents: any;
  action: any;
  isActionLoading = true;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private formBuilder: FormBuilder, public activatedRoute: ActivatedRoute, public instanceService: InstancesService,
    public matdialogRef: MatDialogRef<RunbookPopupComponent>, public runbookService: RunbookService, private componentService: ComponentsService,private matDialog: MatDialog, private urlService: UrlService) {
  }

  ngOnInit(): void {
    this.value = this.data.runbook;
    this.instance = this.data.name;

    const inputs = this.data.runbook.inputs;
    const paramKeys = Object.keys(inputs);

    const objects = paramKeys.filter(k => typeof inputs[k] === 'object');

    this.dynamicParamName = objects[0];
    this.dynamicParams = Object.entries(inputs[this.dynamicParamName]).map(([key, value]) => ({ key, value }));
    this.getComponents(); 
  }

  getComponents(): void {
    const componentType = 'runbook';
        this.componentService.getComponents(componentType)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(data => {
          this.filteredComponents = data;

          this.action = this.filteredComponents
              ?.find(c => c.name === this.value?.componentName);

          this.action = this.action?.displayName?.trim() || this.value?.componentName?.trim() || '-';
              this.isActionLoading = false;
        });
    }

  getValue(value: any): string {
    if (!value || (typeof value === 'object' && Object.keys(value).length === 0)) {
    return '-';
  }

  if (typeof value === 'object') {
    return JSON.stringify(value, null, 2);
  }

  return value;
}

openExternalLink(pipelineId: string): void {
  if (pipelineId) {
    const adoUrl = this.urlService.buildADOPipelineUrl(pipelineId);

    if (adoUrl) {
      const dialogData = {
        redirectTitle: translate('ADD_INSTANCE.ADO_PIPELINE'),
        redirectMsg: translate('INSTANCE_DETAILS.ADO_PIPELINE'),
        proceedButtonText: translate('BUTTONS.PROCEED')
      };
      this.matDialog.open(RedirectionDialogComponent, {
        panelClass: 'default-dialog-wrapper',
        width: '566px',
        autoFocus: false,
        data: dialogData,
        disableClose: false
      }).afterClosed().subscribe(result => {
        if (result) {
          window.open(adoUrl, '_blank');
        }
      });
    }
  }
}
}
